String.prototype.capitalize = function(){
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
}

String.prototype.titleize = function(){
  var arr = this.split(' ');
  arr = arr.map(function(str){ return str.capitalize() });
  return arr.join(' ');
}
